<template>
    <el-popover trigger="hover" placement="right" popper-class="c-el-popover-blue event-list-item-popover">
        <div slot="reference" class="event-list-item" @click="handleClick">
            <div class="event-list-item__title">
                <div class="title-name">{{ data.name }} </div>
                <i class="iconfont icon-dingwei item-icon" @click="handleClick"></i>
            </div>
            <div class="event-list-item__info">
                <span class="event-list-item__info-label">{{ $t('service.data.eventType') }}</span>
                <span class="event-list-item__info-value">{{ data.eventTypeName }}</span>

            </div>
            <div class="event-list-item__info">
                <span class="event-list-item__info-label">{{$t('dataMessage.suspectEvent.detectionTime') }}</span>
                <span class="event-list-item__info-value">{{ data.eventTime }}</span>
            </div>
        </div>
        <div>

            <EventPop :itemObj="data" :border="false" />
        </div>
    </el-popover>
</template>

<script>
import EventPop from '@/page/mainPage/mapComponents/EventPop.vue';
/**
 * @description 事件列表项
 * @example
 * <EventListItem :data="data" @click="handleClick" />
 * @param {Object} data 事件数据
 * emit: click 点击事件回调
 */
export default {
    name: 'EventListItem',
    components: {
        EventPop,
    },
    props: {
        data: {
            type: Object,
            default: () => ({

            }),
        },
    },

    data () {
        return {};
    },
    computed: {},
    methods: {
        handleClick () {
            this.$emit('click', this.data);
        },
    },
    mounted () { },
};
</script>

<style lang="scss" scoped>
.event-list-item {

    padding: 6px 8px;
    background: #112D7B;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #1A47A4;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 15px;

    &__info {
        display: flex;
        align-items: center;

        &-label {
            color: rgba(255, 255, 255, 0.6);
            margin-right: 4px;
        }

    }

    &__title {
        color: rgba(255, 255, 255, 0.9);
        display: flex;

        .title-name {
            width: 95%;
        }
    }

    &__time {
        color: #A1A1A1
    }

    &:not(:last-child) {
        margin-bottom: 8px;
    }

    &:hover,
    &.is-active {
        background: #1A47A4;
    }
}
</style>
<style lang="scss">
.event-list-item-popover {
    background: #071150 !important;

}
</style>
